import { gql } from "@apollo/client";

export const GET_BLOGS = gql`
  query BlogsList {
    mpBlogPosts(action: "get_post_list", currentPage: 1, sortBy: "Popular") {
      total_count
      pageInfo {
        currentPage
        endPage
        hasNextPage
        hasPreviousPage
        pageSize
        startPage
      }
      items {
        post_id
        allow_comment
        author_id
        author_name
        author_url
        author_url_key
        created_at
        enabled
        image
        import_source
        in_rss
        layout
        meta_description
        meta_keywords
        meta_robots
        meta_title
        name
        post_content
        post_id
        publish_date
        short_description
        store_ids
        updated_at
        url_key
        view_traffic
      }
    }
  }
`;

export const GET_BLOG_DETAILS = gql`
  query BlogDetails($urlKey: String!) {
    mpBlogPosts(
      action: "get_post_by_categoryId"
      categoryId: "2"
      filter: { url_key: { eq: $urlKey } }
    ) {
      items {
        banner
        post_id
        allow_comment
        author_id
        author_name
        author_url
        author_url_key
        created_at
        enabled
        image
        import_source
        in_rss
        layout
        meta_description
        meta_keywords
        meta_robots
        meta_title
        name
        post_content
        post_id
        publish_date
        short_description
        store_ids
        updated_at
        url_key
        view_traffic
      }
    }
  }
`;

export const SET_BLOG_VIEW = gql`
  mutation setBlogViews($urlKey: String!) {
    blogViewAddCount(input: { url_key: $urlKey }) {
      view_count
      success_message
    }
  }
`;

export const GET_SEARCH_BLOGS = gql`
  query BlogsList($keyword: String!, $currentPage: Int!) {
    mpBlogPosts(
      action: "get_post_list"
      filter: { name: { like: $keyword } }
      currentPage: $currentPage
      sortBy: "Popular"
      pageSize: 12
    ) {
      total_count
      pageInfo {
        currentPage
        endPage
        hasNextPage
        hasPreviousPage
        pageSize
        startPage
      }
      items {
        post_id
        allow_comment
        author_id
        author_name
        author_url
        author_url_key
        created_at
        enabled
        image
        import_source
        in_rss
        layout
        meta_description
        meta_keywords
        meta_robots
        meta_title
        name
        post_content
        post_id
        publish_date
        short_description
        store_ids
        updated_at
        url_key
        view_traffic
      }
    }
  }
`;

export const GET_BLOGS_CATEGORY_LIST = gql`
  query GET_BLOGS_CATEGORY_LIST {
    mpBlogCategories(action: "get_category_list") {
      items {
        category_id
        enabled
        name
        path
        position
        url_key
      }
    }
  }
`;

export const GET_BLOGS_BASED_ON_CATEGORY = gql`
  query GET_BLOGS_BASED_ON_CATEGORY($categoryId: Int!, $currentPage: Int!) {
    mpBlogPosts(
      action: "get_post_by_categoryId"
      categoryId: $categoryId
      pageSize: 10
      currentPage: $currentPage
    ) {
      total_count
      pageInfo {
        currentPage
        endPage
        hasNextPage
        hasPreviousPage
        pageSize
        startPage
      }
      items {
        allow_comment
        author_id
        author_name
        author_url
        author_url_key
        created_at
        enabled
        image
        import_source
        in_rss
        layout
        meta_description
        meta_keywords
        meta_robots
        meta_title
        name
        post_content
        post_id
        publish_date
        short_description
        store_ids
        updated_at
        url_key
        view_traffic
      }
    }
  }
`;

export default {
  getBlogsQuery: GET_BLOGS,
  getBlogDetails: GET_BLOG_DETAILS,
  setBlogViewsQuery: SET_BLOG_VIEW,
  getBlogSearchQuery: GET_SEARCH_BLOGS,
};
